module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THOMAS DUNNE BOOKS.")]), _c('br'), _vm._v("An imprint of St. Martin’s Press.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ANCIENTS.")]), _vm._v(" Copyright © 2008 by David Lynn Golemon. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "href": "http://www.thomasdunnebooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.thomasdunnebooks.com")]), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.stmartins.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stmartins.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Maps by Paul J. Pugliese")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Golemon, David Lynn.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Ancients : an Event Group thriller / David Lynn Golemon.—1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("         p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("ISBN-13: 978-0-312-35264-6")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("ISBN-10: 0-312-35264-6")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("1. Event Group (Imaginary organization)—Fiction. 2. Atlantis (Legendary place)—Fiction. 3. United States—Politics and government—Fiction. 4. Imaginary wars and battles—Fiction. 5. Weapons of mass destruction—Fiction. 6. Technology—Social aspects—Fiction. 7. Earthquakes—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("PS3607.O4555A53   2008")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("813′.6—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightr"
  }, [_vm._v("2008012927")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First Edition: August 2008")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322dcd54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0